var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonCell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52077 47.5637C7.52077 25.4485 25.4466 7.52077 47.5637 7.52077C69.6808 7.52077 87.6066 25.4466 87.6066 47.5637C87.6066 69.6808 69.6808 87.6066 47.5637 87.6066C25.4466 87.6066 7.52077 69.6808 7.52077 47.5637ZM30.6938 45.8837H45.8837V30.6938C45.8837 29.7673 46.6352 29.0138 47.5637 29.0138C48.4921 29.0138 49.2436 29.7673 49.2436 30.6938V45.8837H64.4336C65.362 45.8837 66.1135 46.6352 66.1135 47.5637C66.1135 48.4902 65.362 49.2436 64.4336 49.2436H49.2436V64.4317C49.2436 65.3601 48.4921 66.1116 47.5637 66.1116C46.6352 66.1116 45.8837 65.3601 45.8837 64.4317V49.2436H30.6938C29.7653 49.2436 29.0138 48.4921 29.0138 47.5637C29.0138 46.6352 29.7653 45.8837 30.6938 45.8837ZM47.5637 10.8807C27.3035 10.8807 10.8807 27.3035 10.8807 47.5637C10.8807 67.8239 27.3015 84.2467 47.5637 84.2467C67.8258 84.2467 84.2467 67.8277 84.2467 47.5637C84.2467 27.3035 67.8239 10.8807 47.5637 10.8807ZM47.5637 0C21.2952 0 0 21.2952 0 47.5637C0 73.8321 21.2952 95.1273 47.5637 95.1273C73.834 95.1273 95.1273 73.834 95.1273 47.5637C95.1273 21.2952 73.8321 0 47.5637 0Z",
    fill: "#4A3A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonCell);
export default __webpack_public_path__ + "static/media/button_cell.2577f9d5034f3d7d4d845d842639bf0f.svg";
export { ForwardRef as ReactComponent };